/**
 * tdesign v0.44.2
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _typeof } from '../_chunks/dep-dfae10c3.js';
import { forwardRef, useMemo, useEffect, useImperativeHandle } from 'react';
import { createPortal } from 'react-dom';
import { canUseDocument } from '../_util/dom.js';
import useConfig from '../hooks/useConfig.js';
import 'raf';
import '../_chunks/dep-10140b37.js';
import '../_chunks/dep-7a9656a6.js';
import '../_chunks/dep-da112583.js';
import '../_chunks/dep-1792ab93.js';
import '../_chunks/dep-1e4c771d.js';
import '../_util/easing.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-74ef9ead.js';
import '../_chunks/dep-5eadc4f3.js';
import '../_chunks/dep-fd215ab0.js';
import '../_chunks/dep-8127363b.js';
import '../_chunks/dep-a0b71ae4.js';
import '../_chunks/dep-670cc86e.js';
import '../_chunks/dep-f4495ac9.js';
import '../_chunks/dep-6c09308a.js';
import '../_chunks/dep-4ca52001.js';
import '../_chunks/dep-408df89a.js';
import '../_chunks/dep-e755a9cb.js';
import '../_chunks/dep-15d0e734.js';
import '../_chunks/dep-b0c02324.js';
import '../_chunks/dep-a09b6dac.js';
import '../_chunks/dep-9c2f4c72.js';
import '../_chunks/dep-da7344ec.js';
import '../_chunks/dep-01fe0fd1.js';
import '../_chunks/dep-20a8e46d.js';
import '../_chunks/dep-9d067299.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../_common/js/global-config/default-config.js';

function getAttach(attach, triggerNode) {
  if (!canUseDocument) return null;
  var el;
  if (typeof attach === "string") {
    el = document.querySelector(attach);
  }
  if (typeof attach === "function") {
    el = attach(triggerNode);
  }
  if (_typeof(attach) === "object" && attach instanceof window.HTMLElement) {
    el = attach;
  }
  if (el && el.nodeType === 1) return el;
  return document.body;
}
var Portal = /*#__PURE__*/forwardRef(function (props, ref) {
  var attach = props.attach,
    children = props.children,
    triggerNode = props.triggerNode;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var container = useMemo(function () {
    if (!canUseDocument) return null;
    var el = document.createElement("div");
    el.className = "".concat(classPrefix, "-portal-wrapper");
    return el;
  }, [classPrefix]);
  useEffect(function () {
    var _parentElement$append;
    var parentElement = getAttach(attach, triggerNode);
    parentElement === null || parentElement === void 0 ? void 0 : (_parentElement$append = parentElement.appendChild) === null || _parentElement$append === void 0 ? void 0 : _parentElement$append.call(parentElement, container);
    return function () {
      var _parentElement$remove;
      parentElement === null || parentElement === void 0 ? void 0 : (_parentElement$remove = parentElement.removeChild) === null || _parentElement$remove === void 0 ? void 0 : _parentElement$remove.call(parentElement, container);
    };
  }, [container, attach, triggerNode]);
  useImperativeHandle(ref, function () {
    return container;
  });
  return canUseDocument ? /*#__PURE__*/createPortal(children, container) : null;
});
Portal.displayName = "Portal";

export { Portal as default, getAttach };
//# sourceMappingURL=Portal.js.map
